import Icon from '../components/Icon.vue'

Icon.register({
  'smile-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM112 223.4C115.3 181.3 144.2 152 168 152S220.7 181.3 224 223.4C224.7 232 213.2 235.3 209.1 227.9L199.6 210.9C191.9 197.2 180.4 189.3 168.1 189.3S144.3 197.2 136.6 210.9L127.1 227.9C122.8 235.3 111.3 231.9 112 223.4zM362.8 346.2C334.3 380.4 292.5 400 248 400S161.7 380.4 133.2 346.2C119.7 329.9 144.2 309.5 157.8 325.7 180.2 352.6 213 367.9 248 367.9S315.8 352.5 338.2 325.7C351.8 309.5 376.3 330 362.8 346.2zM369 227.9L359.5 210.9C351.8 197.2 340.3 189.3 328 189.3S304.2 197.2 296.5 210.9L287 227.9C282.9 235.2 271.4 231.9 272.1 223.4 275.4 181.3 304.3 152 328.1 152S380.8 181.3 384.1 223.4C384.7 232 373.1 235.3 369 227.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smile-beam.js
// module id = GDyZ
// module chunks = 144